var _rect, _ellipse, _g, _g2, _rect2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 114,
    viewBox: "0 0 119 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.907227,
    width: 118,
    height: 114,
    rx: 57,
    fill: "#2F1E3B",
    fillOpacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.9072,
    cy: 57,
    rx: 43,
    ry: 41,
    fill: "#2F1E3B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_486_1529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.9072,
    y: 30,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint0_linear_486_1529)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_486_1529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.9072,
    y: 47,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint1_linear_486_1529)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.9072,
    y: 48,
    width: 18,
    height: 18,
    fill: "url(#pattern0)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_486_1529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.9072,
    y: 86,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint2_linear_486_1529)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_486_1529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.9072,
    y: 59,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint3_linear_486_1529)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_486_1529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.9072,
    y: 68,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint4_linear_486_1529)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_486_1529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.9072,
    y: 44,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint5_linear_486_1529)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_486_1529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.9072,
    y: 48,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint6_linear_486_1529)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_486_1529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.9072,
    y: 85,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint7_linear_486_1529)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_486_1529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.9072,
    y: 78,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint8_linear_486_1529)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_486_1529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.9072,
    y: 91,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint9_linear_486_1529)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_486_1529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.9072,
    y: 20,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint10_linear_486_1529)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_486_1529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.9072,
    y: 44,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint11_linear_486_1529)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_486_1529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.9072,
    y: 30,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint12_linear_486_1529)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_486_1529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.9072,
    y: 31,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint13_linear_486_1529)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_486_1529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.9072,
    y: 68,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "url(#paint14_linear_486_1529)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_486_1529",
    x: 41.9072,
    y: 29,
    width: 3,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_486_1529"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_486_1529",
    x: 93.9072,
    y: 46,
    width: 3,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_486_1529"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_486_1529",
    transform: "scale(0.00195312)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_486_1529",
    x: 63.9072,
    y: 85,
    width: 3,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_486_1529"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_486_1529",
    x: 27.4072,
    y: 58.5,
    width: 2,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_486_1529"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_486_1529",
    x: 36.4072,
    y: 67.5,
    width: 2,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_486_1529"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_486_1529",
    x: 35.4072,
    y: 43.5,
    width: 2,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_486_1529"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_486_1529",
    x: 82.4072,
    y: 47.5,
    width: 2,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_486_1529"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_486_1529",
    x: 77.4072,
    y: 84.5,
    width: 2,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_486_1529"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_486_1529",
    x: 37.4072,
    y: 77.5,
    width: 2,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_486_1529"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_486_1529",
    x: 52.4072,
    y: 90.5,
    width: 2,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_486_1529"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_486_1529",
    x: 59.4072,
    y: 19.5,
    width: 2,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_486_1529"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_486_1529",
    x: 74.4072,
    y: 43.5,
    width: 2,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_486_1529"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_486_1529",
    x: 30.4072,
    y: 29.5,
    width: 2,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_486_1529"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_486_1529",
    x: 68.9072,
    y: 30,
    width: 3,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_486_1529"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_486_1529",
    x: 80.9072,
    y: 67,
    width: 3,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_486_1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_486_1529",
    x1: 43.4072,
    y1: 30,
    x2: 43.4072,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_486_1529",
    x1: 95.4072,
    y1: 47,
    x2: 95.4072,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_486_1529",
    x1: 65.4072,
    y1: 86,
    x2: 65.4072,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_486_1529",
    x1: 28.4072,
    y1: 59,
    x2: 28.4072,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_486_1529",
    x1: 37.4072,
    y1: 68,
    x2: 37.4072,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_486_1529",
    x1: 36.4072,
    y1: 44,
    x2: 36.4072,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_486_1529",
    x1: 83.4072,
    y1: 48,
    x2: 83.4072,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_486_1529",
    x1: 78.4072,
    y1: 85,
    x2: 78.4072,
    y2: 86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_486_1529",
    x1: 38.4072,
    y1: 78,
    x2: 38.4072,
    y2: 79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_486_1529",
    x1: 53.4072,
    y1: 91,
    x2: 53.4072,
    y2: 92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_486_1529",
    x1: 60.4072,
    y1: 20,
    x2: 60.4072,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_486_1529",
    x1: 75.4072,
    y1: 44,
    x2: 75.4072,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_486_1529",
    x1: 31.4072,
    y1: 30,
    x2: 31.4072,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_486_1529",
    x1: 70.4072,
    y1: 31,
    x2: 70.4072,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_486_1529",
    x1: 82.4072,
    y1: 68,
    x2: 82.4072,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_486_1529",
    width: 512,
    height: 512,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.7074b9732601f9aa8584c84842bc9ec4.svg";
export { ForwardRef as ReactComponent };